export enum SupportContactTypeEnum {
    link = 1,
    telefone = 2,
    email = 3,
    whatsapp = 4
}